"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApTooltipReference = exports.ApTooltipManager = exports.ApTooltip = void 0;
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var react_popper_1 = require("react-popper");
Object.defineProperty(exports, "ApTooltipManager", { enumerable: true, get: function () { return react_popper_1.Manager; } });
Object.defineProperty(exports, "ApTooltipReference", { enumerable: true, get: function () { return react_popper_1.Reference; } });
var setReactRef_1 = require("../../utils/setReactRef");
var ApTooltip_styles_1 = require("./ApTooltip.styles");
/**
 * Robust and composable tooltip.
 * This component is similar to ApPopover component
 *
 * It builds upon [Popper.js](https://popper.js.org) and all of its positioning logic,
 * e.g.:
 *
 * - it never hides behind window boundaries (or boundaries of the parent scroll element)
 * - it repositions itself as the user scrolls
 * - its position always follows the button (tooltip reference)
 *
 * See the story, https://popper.js.org and https://github.com/FezVrasta/react-popper
 * for documentation and examples of usage.
 */
var Tooltip = function (_a) {
    var children = _a.children, onClose = _a.onClose, className = _a.className, _b = _a.hideArrow, hideArrow = _b === void 0 ? false : _b, _c = _a.disableOutsideClick, disableOutsideClick = _c === void 0 ? false : _c, _d = _a.enterDelay, enterDelay = _d === void 0 ? 500 : _d, _e = _a.initialOpen, initialOpen = _e === void 0 ? false : _e, modifiers = _a.modifiers, _f = _a.stopPropagation, stopPropagation = _f === void 0 ? true : _f, _g = _a.containerProps, containerProps = _g === void 0 ? {} : _g, message = _a.message, rest = __rest(_a, ["children", "onClose", "className", "hideArrow", "disableOutsideClick", "enterDelay", "initialOpen", "modifiers", "stopPropagation", "containerProps", "message"]);
    var _h = __read(react_1.useState(initialOpen), 2), isOpen = _h[0], setOpen = _h[1];
    var enterTimer = react_1.useRef();
    var childRef = children.ref;
    react_1.useLayoutEffect(function () {
        if (initialOpen) {
            setOpen(initialOpen);
        }
    }, [initialOpen]);
    // Clear timeout on unmount
    react_1.useEffect(function () { return function () {
        clearTimeout(enterTimer.current);
    }; }, []);
    var showTooltip = react_1.useCallback(function () {
        clearTimeout(enterTimer.current);
        if (enterDelay) {
            enterTimer.current = window.setTimeout(function () {
                setOpen(true);
            }, enterDelay);
        }
        else {
            setOpen(true);
        }
    }, [enterDelay]);
    var hideTooltip = react_1.useCallback(function () {
        setOpen(false);
        clearTimeout(enterTimer.current);
    }, []);
    var ownRef = react_1.useRef();
    var handleRef = react_1.useCallback(function (value) {
        // If child has a `ref` already we must not override it
        setReactRef_1.setReactRef(childRef, value);
        ownRef.current = value;
    }, [childRef, ownRef]);
    return (React.createElement(React.Fragment, null,
        React.cloneElement(children, {
            onMouseEnter: showTooltip,
            onMouseLeave: hideTooltip,
            ref: handleRef,
        }),
        isOpen && message && (React.createElement(ApTooltip_styles_1.TooltipContainer, __assign({ disableOutsideClick: true, onClose: hideTooltip, hideArrow: hideArrow, className: className, referenceElement: ownRef.current, modifiers: {
                offset: { offset: '0, 4' }
            } }, rest), message))));
};
exports.ApTooltip = react_1.memo(Tooltip);
//# sourceMappingURL=ApTooltip.js.map